import React, { useState, useEffect, useContext, useRef } from "react";
import { TfiSearch } from "react-icons/tfi";
import { FilterContext } from "../../context/Filter";
import { fetchAccountName, fetchKACode, fetchArnNumber, fetchCompCountData } from "./KpiSearch";
import { cacAndCsrProblem } from "../../pages/analysisData/KpiAnalysis";
import {
  ssoData,
  ssoCsrData,
  ssoCacData,
} from "../../pages/SsoPage/ssoKPI/SSOKpi";

const Search = ({
  activeSSO,
  setSsoData,
  selectedSearchType,
  setSelectedSearchType,
  searchData,
  setSearchData,
  setComplaintData,
  activeL1,
  // isToggle,
  // setIstoggle,
}) => {
  const [filterOptions, setFilterOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const { isToggle, setIstoggle, } = useContext(FilterContext)
  const [searchTerm, setSearchTerm] = useState("");


  const fetchComplaintData = async (searchData) => {
    // console.log(searchData, "----------------");
    try {
      // setLoading(true);
      const apiData = await cacAndCsrProblem(searchData);
      //console.log(apiData, "-------------------");
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setComplaintData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setComplaintData([]);
    } finally {
      // setLoading(false);
    }
  };

  const fetchSSO = async (searchData) => {
    try {
      // setLoading(true);
      const apiData = await ssoData(searchData);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setSsoData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setSsoData([]);
    } finally {
      // setLoading(false);
    }
  };

  const fetchSSOWorkShop = async (searchData) => {
    // console.log(searchData,'-----------------------');
    try {
      // setLoading(true);
      const apiData = await ssoCsrData(searchData);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setSsoData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setSsoData([]);
    } finally {
      // setLoading(false);
    }
  };

  const fetchSSOEnrout = async (searchData) => {
    // console.log(searchData);
    try {
      // setLoading(true);
      const apiData = await ssoCacData(searchData);
      // console.log(apiData, "------------------");
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        setSsoData({ result: [] });
        return;
      }
      setSsoData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setSsoData([]);
    } finally {
      // setLoading(false);
    }
  };

  const fetchOptions = async (searchType) => {
    setIsLoading(true);
    try {
      let data = [];
      if (searchType === "accName") {
        data = await fetchAccountName();
      } else if (searchType === "kaCode") {
        data = await fetchKACode();
      } else if (searchType === "arnNum") {
        data = await fetchArnNumber();
      }

      setFilterOptions(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilterOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDropdownChange = async (e) => {
    const searchType = e.target.value;
    setSelectedSearchType(searchType);
    setSearchData([]);
    if (searchType) {
      await fetchOptions(searchType);
    } else {
      setFilterOptions([]);
    }
  };

  const handleCheckboxChange = (value) => {
    setSearchData((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };



  const handleSelectAll = () => {
    const filteredOptions = filterOptions
      .map((option) => option.data)
      .filter((value) =>
        value.toLowerCase().includes(searchTerm.toLowerCase())
      );

    if (filteredOptions.every((value) => searchData.includes(value))) {
      setSearchData(searchData.filter((item) => !filteredOptions.includes(item)));
    } else {
      setSearchData([...new Set([...searchData, ...filteredOptions])]);
    }
  };

  const filteredOptions = filterOptions.filter((option) =>
    option.data.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectChange = () => {
    setIstoggle(false);
    setIsOpenDropdown(!isOpenDropdown)
  }

  const handleSearch = async () => {

    setIstoggle((prev) => !prev);
    if (searchData?.length && selectedSearchType) {
      // await fetchTotalComplaintSearch(searchData);
      if (activeL1) {
        await fetchComplaintData(searchData);
      }
      if (activeSSO === "SSO Total Complaints") {
        await fetchSSO(searchData);
      }
      if (activeSSO === "SSO Workshop Complaints") {
        await fetchSSOWorkShop(searchData);
      }
      if (activeSSO === "SSO Enroute Complaints") {
        await fetchSSOEnrout(searchData);
      }
    }
    // setIstoggle(false);
  };
  return (
    <div className="flex flex-col gap-2 justify-center items-center pt-3">
      <div className="flex gap-2 items-center justify-center w-full transition-all">
        {/* Dropdown to select search type */}
        <select
          className="h-10 border md:w-56  rounded-md w-full text-sm"
          onChange={handleDropdownChange}
          value={selectedSearchType}
        >
          <option value="">Select Search Type</option>
          <option value="accName">Account Name</option>
          <option value="kaCode">KA Code</option>
          <option value="arnNum">ARN Number</option>
        </select>

        {/* Multi-Select Dropdown */}
        <div className="relative max-w-md z-10">
          <div
            className=" w-full md:w-72 border border-gray-300 text-gray-700 text-sm rounded-lg p-2 cursor-pointer focus:ring-2 focus:ring-blue-500 bg-white"
            onClick={handleSelectChange}
          >
            {(searchData || []).length === 0
              ? "Select Filter Data"
              : searchData.length > 1
                ? `${searchData.length} selected`
                : searchData.join(", ")}
          </div>

          {selectedSearchType && isOpenDropdown && (
            <div className="absolute left-0 top-full w-full bg-white border border-gray-300 rounded-md shadow-md max-h-60 overflow-y-auto mt-1">
              <ul className="p-2">
                {/* Search Box */}
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 mb-2"
                />

                {/* Select All Option */}
                <li className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={
                      filteredOptions.length > 0 &&
                      filteredOptions.every((option) =>
                        searchData.includes(option.data)
                      )
                    }
                    onChange={handleSelectAll}
                  />
                  <label className="truncate w-full font-semibold">Select All</label>
                </li>

                {/* Loading State */}
                {isLoading ? (
                  <div className="flex justify-center items-center p-4">
                    <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                ) : (
                  filteredOptions.map((option, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        className="cursor-pointer"
                        checked={searchData.includes(option.data)}
                        onClick={() => handleCheckboxChange(option.data)}
                      />
                      <label title={option.data} className="truncate w-full">
                        {option.data.length > 35
                          ? `${option.data.slice(0, 35)}...`
                          : option.data}
                      </label>
                    </li>
                  ))
                )}
              </ul>
            </div>
          )}
        </div>

        {/* Search Button */}
        <button
          className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center justify-items-center text-sm max-w-8 w-full"
          title="Search"
          onClick={() => {
            handleSearch();
            setIsOpenDropdown(false);
          }}
        >
          <TfiSearch />
        </button>
      </div>
    </div>
  );
};

export default Search;
